import React from "react";
import { Pencil, Trash2 } from "lucide-react";
import CustomTable from "@/shared/components/ui/Button/CustomTable";
import CommonDropdownMenu from "@/shared/components/ui/DropDown/DropdownMenu";

const statusLabels = {
  in_process: "In Process",
  won: "Won",
  lost: "Lost",
};

const statusColors = {
  in_process: "bg-secondary-ultra-light text-secondary",
  won: "bg-success-50 text-success-600",
  lost: "bg-error-50 text-error-500",
};

const formatAmount = (amount, currency = "USD") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);

const formatDate = (value) => {
  if (!value) return "—";
  try {
    const date = new Date(value);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }) + ".";
  } catch {
    return "—";
  }
};

const COLUMNS = [
  { uid: "name", name: "Deal Name", sortable: true },
  { uid: "amount", name: "Deal Amount", sortable: true },
  { uid: "status", name: "Stage", sortable: true },
  { uid: "pipeline", name: "Pipeline", sortable: true },
  { uid: "owner", name: "Owner" },
  { uid: "createdDate", name: "Created Date", sortable: true },
  { uid: "actions", name: "Actions", align: "center" },
];

const CustomTableDeals = ({
  deals,
  onDealClick,
  onEdit,
  onDelete,
  selectedDeals,
  setSelectedDeals,
}) => {
  const renderCell = (deal, columnKey) => {
    switch (columnKey) {
      case "name":
        return (
          <div className="flex items-center gap-2">
            <span className=" text-gray-800 font-normal truncate max-w-[160px]">
              {deal.name}
            </span>
          </div>
        );
      case "amount":
        return (
          <span className="font-normal text-gray-500">
            {formatAmount(deal.amount, deal.currency)}
          </span>
        );
      case "status":
        return (
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-normal ${statusColors[deal.status] || "bg-gray-50 text-gray-500"
              }`}
          >
            {statusLabels[deal.status] || deal.status}
          </span>
        );
      case "pipeline":
        return <span className="text-gray-500">{deal.pipeline || "—"}</span>;
      case "owner":
        return <span className="text-gray-500">{deal.owner?.name || "—"}</span>;
      case "createdDate":
        return (
          <span className="text-gray-500">{formatDate(deal.createdDate)}</span>
        );
      case "actions":
        return (
          <div onClick={(e) => e.stopPropagation()} className="flex justify-center items-center">
            <CommonDropdownMenu
              itemId={deal.id}
              iconSize={18}
              actions={[
                {
                  id: "edit",
                  name: "Edit",
                  icon: <Pencil size={15} />,
                  onClick: () => onEdit(deal),
                },
                {
                  id: "delete",
                  name: "Delete",
                  icon: <Trash2 size={15} className="text-error-500" />,
                  onClick: () => onDelete(deal),
                },
              ]}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-xl overflow-hidden">
      <CustomTable
        data={deals}
        columns={COLUMNS}
        renderCell={renderCell}
        onRowClick={onDealClick}
        disableRowClickKeys={["actions"]}
        tableLayout="auto"
        height="auto"
        enableSelection={true}
        selectedItems={selectedDeals}
        onSelectionChange={setSelectedDeals}
        headerColor="headerLight"
      />
    </div>
  );
};

export default CustomTableDeals;
